import React from 'react';
import classnames from 'classnames';

// @ts-ignore
import style from './Content.sass';

export interface Props {
  className?: string;
}

export default class Content extends React.PureComponent<Props> {
  render() {
    return <div {...this.props} className={classnames(style.root, this.props.className)} />;
  }
}
